import { Injectable } from '@angular/core';

// import { SupplementModel, SupplementStackModel } from '../../models/models';
import { ApiProvider } from '../api/api';
import { SupplementProvider } from './supplement';

@Injectable()
export class SupplementStackProvider {
//   private items: SupplementModel[] = [];

  constructor(
    private api: ApiProvider,
    private supplementProvider: SupplementProvider) {
  }

  LoadSupplementItems(supplement_id: number) {
    return new Promise((resolve, reject) => {
      this.api.get(`supplement-stack/${supplement_id}`).subscribe((data) => {
        const arr = data.json();

        let obj: any[] = [];

        for(var j = 0; j < arr.length; j++) {
          var item = arr[j];

          obj.push({
            _id: item.id,
            SupplementId: item.supplement_id,
            Name: item.name,
            Brand: item.brand,
            Portion: item.portion,
            Serving: Number(item.serving),
            StartDate: item.start_date
          });
        }

        // sort items for the stack
        obj = this.supplementProvider.Sort(obj);

        resolve(obj);
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/supplement/supplement-stack.ts